var map = {
	"./mountain-badge--dark.svg": 1484,
	"./mountain-badge--light.svg": 1485,
	"./surf-badge--dark.svg": 1486,
	"./surf-badge--light.svg": 1487,
	"./tide-badge--dark.svg": 1488,
	"./tide-badge--light.svg": 1489,
	"./weather-badge--dark.svg": 1490,
	"./weather-badge--light.svg": 1491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1483;